module.exports = __webpack_public_path__ + "static/media/clap.6d1e1b2f.png";